import { hot } from 'react-hot-loader/root';
import Component from './createAsset-redux';

export default hot(Component);
